export function build(VERSION) {
  return {
    templateUrl: 'assets/js/angular/views/partials/build.html?id=' + VERSION,
  }
}
